<template>
  <fieldset class="radio-group-fieldset">
    <legend v-if="label" class="radio-group-legend visually-hidden">{{ label }}</legend>
    <div class="btn-group btn-group-toggle row g-2 w-100" data-toggle="buttons" role="presentation">
      <div v-for="(option,idx) in options" :key="idx" class="col-4 position-relative">
        <input type="radio" class="btn-check" :name="name" :value="option.val" :checked="option.val==value" :id="`item_` + name + `_` + idx " :aria-required="fieldAriaRequired" :aria-describedby="fieldDescribedBy" :aria-invalid="fieldAriaInvalid">
        <label class="btn btn1 text-center align-middle f14-l18" :for="`item_` + name + `_` + idx " v-html="option.text || option.text_html"></label>
        <img src="@/assets/icons/check-selected.png" class="btn1-check-mark" alt="" aria-hidden="true" />
      </div>
    </div>
    <div class="invalid-feedback" :id="`${name}invalid`">{{field?.error_message}}</div>
  </fieldset>
</template>
<script>
import formFieldA11y from '@/mixins/formFieldA11y.js'

export default {
  mixins: [formFieldA11y],
  props: {
    label: String,
    type: String,
    name: String,
    value: Number,
    options: Array,
    field: Object,
  }
}
</script>
<style scoped>
.radio-group-fieldset {
  border: none;
  margin: 0;
  padding: 0;
  min-width: 0;
}

.radio-group-legend {
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  float: none;
  width: auto;
}

.btn1 {
  border: 1px solid #bbbaba;
  border-radius: 20px;
  background: white;
  margin: 0 5px;
  display: block;
  text-align: center;
  color: #171717;
  text-decoration: none;
  width: 100%;
}

.btn-check:checked + .btn1 {
  color: #ef3d49;
  border-color: #ef3d49;
  background-color: #f9f9f9;
}

.btn1-check-mark {
  position: absolute;
  top: 10px;
  right: 20px;
  display: none;
}

.btn-check:checked ~ .btn1-check-mark {
  display: block;
}
</style>
